import { createSelector } from 'reselect';

import { AppState } from '../rootReducer';

const getItems = (state: AppState) => state.APInvoice.items;
const getItemView = (state: AppState) => state.APInvoice.itemView;

export const getAPInvoiceSelector = createSelector(getItems, items => items);
export const getAPInvoiceViewSelector = createSelector(getItemView, itemView => itemView);